/** Frozen account-block.v2.md §2. No text interpretation or inferred tier. */
export const ACCOUNT_BLOCK_VERSION = "account-block@2.0.0";
export const BLOCK_REASONS = [
  { code: "harassment_or_unsafe", label: "被骚扰，或让我感到不安全", tier: "hard" },
  { code: "stalking_or_persistent", label: "被跟踪或纠缠", tier: "hard" },
  { code: "unwanted_physical_contact", label: "有过不当的身体接触", tier: "hard" },
  { code: "insult_or_threat", label: "言语侮辱或威胁", tier: "hard" },
  { code: "not_stated", label: "不想说明", tier: "hard" },
  { code: "other", label: "其他（可以自己写）", tier: "hard" },
  { code: "just_not_compatible", label: "只是合不来，没有安全问题", tier: "best_effort" },
] as const;
export type BlockReasonCode = typeof BLOCK_REASONS[number]["code"];
export type StoredBlockReasonCode = BlockReasonCode | "legacy_unspecified";
export type BlockTier = "hard" | "best_effort";

export function blockTier(code: unknown): BlockTier {
  if (code === "legacy_unspecified") return "hard";
  const reason = BLOCK_REASONS.find((entry) => entry.code === code);
  if (!reason) throw new Error("Unknown block reason");
  return reason.tier;
}

/** Code points, as in SQLite length(); no trimming, classification or normalization of the note. */
export function parseBlockReason(reasonCode: unknown, note: unknown, allowMissing = false): {
  reasonCode: BlockReasonCode; tier: BlockTier; note: string | null;
} {
  const code = reasonCode === undefined && allowMissing ? "not_stated" : reasonCode;
  if (!BLOCK_REASONS.some((entry) => entry.code === code)) throw new Error("请选择屏蔽原因");
  if (note !== undefined && note !== null && (typeof note !== "string" || code !== "other"
    || Array.from(note).length > 200 || note.includes("\0"))) throw new Error("补充说明仅限其他原因，最多 200 个字");
  return { reasonCode: code as BlockReasonCode, tier: blockTier(code), note: typeof note === "string" ? note : null };
}
